import React from "react";
import { FormRow, Column } from "components/common/html";
import { RadioGroupBasic } from "../index";

/**
 * Deprecated, use material for new code
 * */
export const RadioYesNo: React.FC<any> = props => (
  <FormRow style={{ marginBottom: props.marginBottom || 1 }}>
    <Column width={8}>
      <p>{props.label}</p>
    </Column>
    <Column width={4}>
      <RadioGroupBasic
        name={props.name}
        row
        options={[
          { label: "Yes", value: true },
          { label: "No", value: false },
        ]}
        defaultValue={props.formData[props.name]}
      />
    </Column>
  </FormRow>
);

// no left column, just yes/no inputs
export const RadioYesNoSmall: React.FC<any> = props => (
  <div>
    <RadioGroupBasic
      name={props.name}
      row
      options={[
        { label: "Yes", value: true },
        { label: "No", value: false },
      ]}
      defaultValue={props.formData[props.name]}
      style={{ display: "inline-block" }}
    />
  </div>
);
